// 결과 화면의 카드 DOM을 보이는 그대로 이미지(PNG Blob)로 만든다.
// html2canvas는 문서를 복제해서 그리므로, 화면과 달라지는 부분은 복제본(onclone)에서만 보정한다.

// 여러 줄로 감긴 인라인 span을 줄마다 span + <br>로 나눈다.
// html2canvas는 box-decoration-break: clone을 지원하지 않아, 감긴 제목 마커가 한 덩어리 박스로 그려지기 때문.
const splitWrappedInline = (span) => {
  const textNode = span.firstChild;
  if (span.childNodes.length !== 1 || textNode.nodeType !== 3) return;
  if (span.getClientRects().length < 2) return;

  const doc = span.ownerDocument;
  const text = textNode.data;
  const range = doc.createRange();
  const lines = [];
  let lineStart = 0;
  let lineTop = null;

  for (let i = 0; i < text.length; i++) {
    range.setStart(textNode, i);
    range.setEnd(textNode, i + 1);
    const rect = range.getClientRects()[0];
    if (!rect || rect.width === 0) continue; // 줄 끝에서 접힌 공백
    if (lineTop !== null && rect.top - lineTop > rect.height / 2) {
      lines.push(text.slice(lineStart, i));
      lineStart = i;
    }
    lineTop = rect.top;
  }
  lines.push(text.slice(lineStart));
  if (lines.length < 2) return;

  const fragment = doc.createDocumentFragment();
  lines.forEach((line, index) => {
    if (index > 0) fragment.appendChild(doc.createElement("br"));
    const lineSpan = span.cloneNode(false);
    // NBSP(어절 붙임)는 살리고 줄 경계의 일반 공백만 제거
    lineSpan.textContent = line.replace(/^[ \t\n]+|[ \t\n]+$/g, "");
    fragment.appendChild(lineSpan);
  });
  span.replaceWith(fragment);
};

export const captureCardImage = async (element, { lineSplitSelector } = {}) => {
  const { default: html2canvas } = await import("html2canvas");
  if (document.fonts && document.fonts.ready) await document.fonts.ready;

  const canvas = await html2canvas(element, {
    scale: 3,
    backgroundColor: null,
    useCORS: true,
    logging: false,
    onclone: async (clonedDoc, clonedElement) => {
      // 짧은 화면에서 줄인 카드 zoom을 풀어 항상 원래 크기로 저장
      clonedDoc.documentElement.style.setProperty("--card-zoom", "1");
      // 등장 전환·하단 밴드 스크롤을 멈춘 최종 상태로
      const style = clonedDoc.createElement("style");
      style.textContent =
        "*, *::before, *::after { animation: none !important; transition: none !important; }";
      clonedDoc.head.appendChild(style);

      // 복제 문서에서도 웹폰트가 적용된 뒤 줄바꿈을 재야 화면과 같다
      clonedElement.getBoundingClientRect();
      if (clonedDoc.fonts && clonedDoc.fonts.ready) await clonedDoc.fonts.ready;

      if (lineSplitSelector) {
        clonedDoc.querySelectorAll(lineSplitSelector).forEach(splitWrappedInline);
      }
    },
  });

  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => (blob ? resolve(blob) : reject(new Error("이미지 변환 실패"))),
      "image/png"
    );
  });
};
